import PropTypes from 'prop-types'

import Button from 'components/common/Button'
import { CodeWrapper, CodeBlock } from 'components/common/Codeblock'
import { CopyButton } from 'components/common/CopyButton'
import TrackedExternalLink from 'components/common/TrackedExternalLink'
import theme from 'theme'

const Windows = ({ colorTheme, ...rest }) => (
  <CodeWrapper {...rest}>
    <div css={{ paddingBottom: theme.space[2] }}>
      <div css={{ display: 'flex', alignItems: 'flex-end' }}>
        <CopyButton
          colorTheme={colorTheme}
          content="msiexec /package https://windows.gremlin.com/installer/latest/gremlin_installer.msi"
        />
      </div>
      <CodeBlock code="msiexec /package https://windows.gremlin.com/installer/latest/gremlin_installer.msi" />
      <Button
        primary
        as={TrackedExternalLink}
        href="https://windows.gremlin.com/installer/latest/gremlin_installer.msi"
      >
        Start install
      </Button>
    </div>
  </CodeWrapper>
)

Windows.propTypes = {
  colorTheme: PropTypes.oneOf(['light', 'dark'])
}

export default Windows
